import { useState, useEffect } from 'react';
import { paymentService } from '../api';
import { PaymentData, Payment, PaymentRequest, PaymentResponse } from '../types';

export const usePaymentData = () => {
  const [paymentData, setPaymentData] = useState<PaymentData | null>(null);
  const [loading, setLoading] = useState<boolean>(true); // Počinje sa true
  const [error, setError] = useState<string | null>(null);
  const [currentToken, setCurrentToken] = useState<string | null>(null);

  const fetchPaymentInfo = async (token: string | null): Promise<void> => {
    if (!token || token.trim() === '') {
      setError('Nemate sve pristupne podatke');
      setLoading(false);
      return;
    }

    try {
      setLoading(true);
      setError(null);
      
      const data = await paymentService.getPaymentInfo(token);
      
      setPaymentData(data);
    } catch (err: any) {
      let errorMsg = 'Greška pri učitavanju informacija o plaćanju';
      
      if (err.response?.data) {
        const responseData = err.response.data;
        
        if (Array.isArray(responseData) && responseData[0] && responseData[0].message) {
          errorMsg = responseData[0].message;
        } else if (typeof responseData === 'object' && responseData.message) {
          errorMsg = responseData.message;
        }
      }
      
      setError(errorMsg);
      console.error('Error:', err);
    } finally {
      setLoading(false);
    }
  };

  return {
    paymentData,
    loading,
    error,
    currentToken,
    setCurrentToken,
    fetchPaymentInfo,
    setError,
    setLoading
  };
};